import { render, staticRenderFns } from "./AccountDividends.html?vue&type=template&id=49a12b0e&scoped=true&"
import script from "./AccountDividends.ts?vue&type=script&lang=ts&"
export * from "./AccountDividends.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_dividends.scss?vue&type=style&index=0&id=49a12b0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a12b0e",
  null
  
)

export default component.exports